import moment from 'moment';
import numeral from 'numeral';
import classnames from 'classnames';
import React, { Component } from 'react';
import styles from './styles.scss';

class ExamTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.interval = setInterval(this.setTime, 200);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  setTime = () => {
    const { allottedTimeMins, startedAt } = this.props;

    const examMoment = moment(startedAt);
    examMoment.add(allottedTimeMins, 'minutes');

    const now = moment();

    const delta = now - examMoment;
    const duration = moment.duration(Math.abs(delta));

    const isOver = delta > 0;

    const minutes = Math.floor(duration.asMinutes());
    const seconds = duration.seconds();
    const time = `${numeral(minutes).format('00')}:${numeral(seconds).format('00')}`;

    this.setState({
      isOver,
      time,
    });
  };

  render() {
    const { isOver, time } = this.state;

    if (!time) {
      return null;
    }

    const classes = classnames([styles.time, isOver && styles.isOver]);

    return (
      <div className={classes} data-aaa="reviewTime">
        {time}
      </div>
    );
  }
}

export default ExamTimer;
